var _filter, _clipPath, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "480px",
    height: "480px",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 480,
    height: 480,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 480,
    height: 480
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 400.039062 249.300781 C 396.792969 249.6875 393.941406 251.636719 392.398438 254.519531 C 358.839844 317.019531 277.820312 390 160 390 C 110.558594 390 29.640625 372.28125 20.980469 260 L 20.179688 260 C 24.539062 381.519531 109.078125 400 160 400 C 277.839844 400 358.839844 327.019531 392.398438 264.519531 C 393.941406 261.636719 396.792969 259.6875 400.039062 259.300781 C 428.761719 255.941406 446.140625 242.28125 454.761719 233.179688 C 452.242188 232.074219 449.679688 231.070312 447.078125 230.179688 C 437.238281 238.160156 422 246.71875 400.039062 249.300781 Z M 400.039062 249.300781 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 1.556,
    y1: 8.195,
    x2: 21.3,
    y2: 17.401,
    gradientTransform: "matrix(20,0,0,20,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100%,100%,100%)",
      stopOpacity: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,23.529412%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 475.398438 221.578125 C 474.019531 220.679688 445.441406 202.640625 418.421875 206.941406 C 411.878906 179.558594 386.761719 162.5 385.519531 161.679688 C 381.496094 158.980469 376.113281 159.5625 372.761719 163.058594 C 370.761719 165.140625 353.421875 184.539062 358.320312 228.699219 C 358.703125 231.675781 357.785156 234.671875 355.800781 236.921875 C 354.082031 238.898438 351.582031 240.027344 348.960938 240 L 340 240 L 340 190 C 340 184.476562 335.523438 180 330 180 L 280 180 L 280 70 C 280 64.476562 275.523438 60 270 60 L 210 60 C 204.476562 60 200 64.476562 200 70 L 200 120 L 90 120 C 84.476562 120 80 124.476562 80 130 L 80 180 L 30 180 C 24.476562 180 20 184.476562 20 190 L 20 240 L 10 240 C 4.476562 240 0 244.476562 0 250 C 0 403.441406 111.898438 420 160 420 C 283.859375 420 369.960938 344.761719 407.539062 278.460938 C 457.058594 270.558594 477.71875 236.578125 478.621094 235.101562 C 481.355469 230.460938 479.933594 224.488281 475.398438 221.578125 Z M 475.398438 221.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.882353%,64.705882%,96.078431%)",
      fillOpacity: 1
    },
    d: "M 280 200 L 320 200 L 320 240 L 280 240 Z M 220 200 L 260 200 L 260 240 L 220 240 Z M 160 200 L 200 200 L 200 240 L 160 240 Z M 100 200 L 140 200 L 140 240 L 100 240 Z M 220 140 L 260 140 L 260 180 L 220 180 Z M 220 80 L 260 80 L 260 120 L 220 120 Z M 160 140 L 200 140 L 200 180 L 160 180 Z M 100 140 L 140 140 L 140 180 L 100 180 Z M 40 200 L 80 200 L 80 240 L 40 240 Z M 40 200 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.882353%,64.705882%,96.078431%)",
      fillOpacity: 1
    },
    d: "M 400.039062 259.300781 C 396.792969 259.6875 393.941406 261.636719 392.398438 264.519531 C 358.839844 327.019531 277.820312 400 160 400 C 109.078125 400 24.558594 381.519531 20.179688 260 L 348.960938 260 C 357.398438 260 365.140625 256.539062 370.738281 250.28125 C 376.480469 243.859375 379.21875 235.199219 378.238281 226.5 C 375.980469 206.101562 379.300781 192.761719 382.519531 185.121094 C 390.019531 192.339844 400 204.820312 400 220 C 400 223.460938 401.800781 226.679688 404.738281 228.519531 C 407.691406 230.320312 411.363281 230.480469 414.460938 228.941406 C 426.359375 222.941406 443.261719 227.980469 454.761719 233.179688 C 446.121094 242.28125 428.738281 255.941406 400.039062 259.300781 Z M 400.039062 259.300781 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.823529%,23.529412%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 120.820312 320 C 120.820312 331.046875 111.867188 340 100.820312 340 C 89.773438 340 80.820312 331.046875 80.820312 320 C 80.820312 308.953125 89.773438 300 100.820312 300 C 111.867188 300 120.820312 308.953125 120.820312 320 Z M 120.820312 320 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.839844 314.578125 C 115.839844 318.148438 112.949219 321.039062 109.378906 321.039062 C 105.8125 321.039062 102.921875 318.148438 102.921875 314.578125 C 102.921875 311.011719 105.8125 308.121094 109.378906 308.121094 C 112.949219 308.121094 115.839844 311.011719 115.839844 314.578125 Z M 115.839844 314.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 475.398438 221.578125 C 474.019531 220.679688 445.441406 202.640625 418.421875 206.941406 C 411.878906 179.558594 386.761719 162.5 385.519531 161.679688 C 381.496094 158.980469 376.113281 159.5625 372.761719 163.058594 C 370.761719 165.140625 353.421875 184.539062 358.320312 228.699219 C 358.703125 231.675781 357.785156 234.671875 355.800781 236.921875 C 354.082031 238.898438 351.582031 240.027344 348.960938 240 L 340 240 L 340 190 C 340 184.476562 335.523438 180 330 180 L 280 180 L 280 70 C 280 64.476562 275.523438 60 270 60 L 210 60 C 204.476562 60 200 64.476562 200 70 L 200 120 L 90 120 C 84.476562 120 80 124.476562 80 130 L 80 180 L 30 180 C 24.476562 180 20 184.476562 20 190 L 20 240 L 10 240 C 4.476562 240 0 244.476562 0 250 C 0 403.441406 111.898438 420 160 420 C 283.859375 420 369.960938 344.761719 407.539062 278.460938 C 457.058594 270.558594 477.71875 236.578125 478.621094 235.101562 C 481.355469 230.460938 479.933594 224.488281 475.398438 221.578125 Z M 475.398438 221.578125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.be93a2b8bd2e357ea8b14caa33cecc67.svg";
export { ForwardRef as ReactComponent };